import { useSnackbar, WithSnackbarProps, OptionsObject } from 'notistack';
import React from 'react';
import { IntlShape, MessageDescriptor, useIntl } from 'react-intl';

interface IProps {
  setUseSnackbarRef: (showSnackbar: WithSnackbarProps) => void;
  setUseIntlRef: (intl: IntlShape) => void;
}

const InnerSnackbarUtilsConfigurator: React.FC<IProps> = (props: IProps) => {
  props.setUseSnackbarRef(useSnackbar());
  props.setUseIntlRef(useIntl());
  return null;
};

let useSnackbarRef: WithSnackbarProps;
const setUseSnackbarRef = (useSnackbarRefProp: WithSnackbarProps) => {
  useSnackbarRef = useSnackbarRefProp;
};

let useIntlRef: IntlShape;
const setUseIntlRef = (useIntlRefProp: IntlShape) => {
  useIntlRef = useIntlRefProp;
};

export const SnackbarUtilsConfigurator = () => {
  return (
    <InnerSnackbarUtilsConfigurator
      setUseSnackbarRef={setUseSnackbarRef}
      setUseIntlRef={setUseIntlRef}
    />
  );
};

// eslint-disable-next-line
export default {
  success(msg: MessageDescriptor | string, options: OptionsObject = {}) {
    this.toast(msg, { ...options, variant: 'success' });
  },
  warning(msg: MessageDescriptor | string, options: OptionsObject = {}) {
    this.toast(msg, { ...options, variant: 'warning' });
  },
  info(msg: MessageDescriptor | string, options: OptionsObject = {}) {
    this.toast(msg, { ...options, variant: 'info' });
  },
  error(msg: MessageDescriptor | string, options: OptionsObject = {}) {
    this.toast(msg, { ...options, variant: 'error' });
  },
  toast(msg: MessageDescriptor | string, options: OptionsObject = {}) {
    if (typeof msg === 'string') {
      useSnackbarRef.enqueueSnackbar(msg, options);
    } else {
      useSnackbarRef.enqueueSnackbar(useIntlRef.formatMessage(msg), options);
    }
  },
};
